// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "0.0.1/static/css/" + "main" + "." + "b9dd3354" + ".css";
};